import { createRootRoute, Outlet } from "@tanstack/react-router";
import { OrganizationGate } from "@/frontend/components/shared/OrganizationGate";
import { CompleteProfileGate } from "@/frontend/components/shared/CompleteProfileGate";
import { PersonaGate } from "@/frontend/components/shared/PersonaGate";
import { Toaster } from "@/frontend/components/ui/sonner";
import { AuthErrorToastHandler } from "@/frontend/components/AuthErrorToastHandler";
import "../index.css";

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <>
      <Toaster richColors closeButton />
      <AuthErrorToastHandler />
      <CompleteProfileGate>
        <OrganizationGate>
          <PersonaGate>
            <Outlet />
          </PersonaGate>
        </OrganizationGate>
      </CompleteProfileGate>
    </>
  );
}
